<template>
  <span
    class="['ml-3', { 'd-block': block }]"
    v-if="question.history || currentConfiguration?.settings?.show_last_reading_answers" >
    <span
      v-if="valueFromHistory"
      class="text-grey-darken-1"
    >
      <i class="v-icon notranslate v-theme--light v-icon--size-small">
        <svg v-if="question.history" class="v-icon__svg" viewBox="0 0 24 24">
          <path :d="mdiHistory" />
        </svg>
      </i>
    [{{ shortHistoryValue }}]
    </span>
    <span
        v-else
        class="text-red-darken-1 font-italic font-weight-thin"
    >
      {{ $t('mission-planning.qst.my-questionnaires.qst.no-history') }}
    </span>

    <button
      v-if="valueFromHistory?.length > VISIBLE_HISTORY_CHAR_LENGTH"
      class="icon-button ml-1"
      :title="fullHistoryValue"
    >
      <svg viewBox="0 0 24 24">
        <path :d="mdiHelpCircleOutline" />
      </svg>
      &nbsp;
    </button>
  </span>
</template>

<script setup>
import { computed, defineProps, inject } from 'vue'
import { QST } from '@/constants';
import {mdiHelpCircleOutline, mdiHistory} from '@mdi/js';
import { useI18n } from "vue-i18n";
import questionsHandler from "@/utils/questionsHandler";

const VISIBLE_HISTORY_CHAR_LENGTH = 150;

const props = defineProps({
  question: {
    type: Object,
    required: false
  },
  missionReadingHistory: {
    type: Object,
    required: false
  },
  attachmentType: {
    type: String,
    required: false
  },
  attachmentId: {
    type: [Number, String],
    required: false
  },
  block: {
    type: Boolean,
    required: false,
    default: false
  }
});

const { t } = useI18n();
const currentConfiguration = inject('currentConfiguration');
const missionReadingHistoryVauesByBuiltId = inject('missionReadingHistoryVauesByBuiltId');

const YES = t('global.text.bool.true');
const NO = t('global.text.bool.false');
const fullHistoryValue = computed(() => valueFromHistory.value || '');
const shortHistoryValue = computed(() => truncateText(fullHistoryValue.value));
const builtId = computed(() => questionsHandler.buildId(
  props.question.id, props.attachmentType, props.attachmentId
));
const valueFromHistory = computed(() => {
  let iValueFromHistory = missionReadingHistoryVauesByBuiltId.value[builtId.value] || null
  if (props.question.data_type?.value === QST.INPUT.TYPE.YES_NO) {
    iValueFromHistory = iValueFromHistory ? (Number(iValueFromHistory) ? YES : NO) : '';
  }
  return iValueFromHistory;
});


function getHistoryValue(valueFromHistory = '', truncated = false) {
  if (truncated) {
    valueFromHistory = truncateText(valueFromHistory);
  }
  return valueFromHistory;
}
function truncateText(str, max = VISIBLE_HISTORY_CHAR_LENGTH) {
  return str.length > max ? str.slice(0, max - 3) + '...' : str;
}
</script>